import { memo } from 'react';

import { Portal } from '@air/primitive-portal';
import { useBreakpointsContext } from '@air/provider-media-query';

import { ContentCollectionEditCustomFieldsButton } from '~/components/ContentCollection/ContentCollectionEditCustomFieldsButton';
import { ContentCollectionItemsSelected } from '~/components/ContentCollection/ContentCollectionItemsSelected';
import { ContentCollectionRemoveItemsButton } from '~/components/ContentCollection/ContentCollectionRemoveItemsButton';
import { ContentCollectionSelectAllButton } from '~/components/ContentCollection/ContentCollectionSelectAllButton';
import { ContentCollectionSubmitButton } from '~/components/ContentCollection/ContentCollectionSubmitButton';
import { ContentCollectionUploadMoreButton } from '~/components/ContentCollection/ContentCollectionUploadMoreButton';
import { ContentCollectionUploadsTrackingPanel } from '~/components/ContentCollection/ContentCollectionUploadsTrackingPanel';

export const ContentCollectionActionBar = memo(() => {
  const { isAboveMediumScreen } = useBreakpointsContext();

  if (isAboveMediumScreen) {
    return (
      <div
        className="mx-8 flex items-center justify-between py-4 md:border-b ads:md:border-b-ads-gray-5 md:border-b-gray-5"
        data-testid="CONTENT_COLLECTION_ACTION_BAR"
      >
        <div className="hidden items-center gap-2 lg:flex">
          <ContentCollectionSelectAllButton />
          <ContentCollectionEditCustomFieldsButton />
          <ContentCollectionRemoveItemsButton />
          <ContentCollectionItemsSelected />
        </div>
        <div className="flex items-center gap-2">
          <ContentCollectionUploadMoreButton />
          <ContentCollectionSubmitButton />
        </div>
      </div>
    );
  }

  return (
    <Portal>
      <div className="fixed inset-x-0 bottom-0 shadow-kanban">
        <ContentCollectionUploadsTrackingPanel className="rounded-0" />
        <div className="flex flex-col gap-2 ads:border-ads-gray-5 border-gray-5 border-t ads:bg-base bg-gray-1 p-4">
          <ContentCollectionSubmitButton />
        </div>
      </div>
    </Portal>
  );
});

ContentCollectionActionBar.displayName = 'ContentCollectionActionBar';
